/**
 * Pulsing amber dot marking a hanke whose Sitedrive schedule has changes
 * waiting to be synced. Shared by the Hankkeet list, the Etusivu hanke cards
 * and the Hankkeet nav item so all three read as the same signal.
 */

import { cn } from "@/lib/utils";

export function SchedulingChangesDot({
  className,
  title,
}: {
  className?: string;
  title?: string;
}) {
  return (
    <span
      className={cn("relative flex h-2 w-2 shrink-0", className)}
      title={title}
      aria-label={title ?? "Sitedrive-muutoksia saatavilla"}
      role="img"
    >
      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75" />
      <span className="relative inline-flex h-2 w-2 rounded-full bg-amber-500" />
    </span>
  );
}
